import { apiDaInscricao } from "../../../servicos/axios";

export interface EditarLocalPayload {
  Id: number;
  Descricao: string;
  IdCidade: number;
  EhCidadeParceira: boolean;
  DataDeVigenciaInicial?: string | null;
  DataDeVigenciaFinal?: string | null;
}

export const editarLocal = async (dados: EditarLocalPayload) => {
  const response = await apiDaInscricao().put(
    "/LocalDeAtendimento/editar",
    dados
  );
  return response.data;
};
